import { GenericObject } from 'types/generic.types';
import React from 'react';
import { ColSpanArgs, Column, RowRendererProps } from 'react-data-grid';
import { ContextMenuOption, DataTestId } from 'types/general.types';
import { BoxProps, SystemStyleObject } from '@chakra-ui/react';
import { ContextMenuProps } from 'app/components/ChakraTableList/ContextMenu/types';
import { LinkProps } from 'react-router-dom';
import { Maybe } from 'yup/lib/types';

export enum RowType {
  SUBHEADER = 'SUBHEADER',
  SUBHEADER_LOADER = 'SUBHEADER_LOADER',
  CUSTOM_CONTENT = 'CUSTOM_CONTENT',
}

export type SummaryRow = GenericObject<string | React.ReactElement>;
export type HeaderRow = GenericObject<
  string | React.ReactElement | object | boolean | number
> & {
  clickable?: boolean;
};

interface RowData extends Object {
  options?: ContextMenuOption[] | null;
}

export type BodyRow = HeaderRow & {
  to?: string | { path: string; state: LinkProps['state'] };
  rowData?: RowData;
  type?: RowType;
  id?: string;
  rows?: BodyRow[];
  onRowClick?: (row: any) => void;
  disabled?: boolean;
  height?: number;
  content?:
    | React.ReactElement
    | ((props: RowContentProps) => React.ReactElement);
  hideBorder?: boolean;
  children?: Array<Omit<BodyRow, 'children'>>;
  className?: string;
  tooltip?: string;
};

export type ColumnType = Column<HeaderRow> & {
  accessory?: boolean;
  contextMenu?: boolean;
  centered?: boolean;
  alignRight?: boolean;
  colSpan?: (args: ColSpanArgs<HeaderRow, unknown>) => Maybe<number>;
};

export interface RowContentProps {
  isSectionCollapsed?: boolean;
}

export interface TableListLoadingOptions {
  withSubheader?: boolean;
  loading: boolean;
  loadingMore?: boolean;
  repeat?: number;
  loader: HeaderRow;
}

export interface TableListProps extends DataTestId, BoxProps {
  scrollable?: boolean;
  memoizeList?: boolean;
  memoizeColumnFormatter?: boolean;
  rows: BodyRow[];
  columns: ColumnType[];
  summaryRows?: SummaryRow[];
  loadingOptions?: TableListLoadingOptions;
  dragCorrectionDistance?: number;
  className?: string;
  onRowClick?: (row: any) => void;
  rowRenderer?: (props: RowRendererProps<BodyRow>) => React.ReactElement;
  regularRowHeight?: number;
  rowKeyGetter?: (row: any) => string;
  onRowsChange?: (row: any) => void;
  fetchMore?: () => Promise<void | null>;
  hasMore?: boolean;
  id?: string;
  wrapperSx?: SystemStyleObject;
  contextMenuProps?: ContextMenuProps;
  variant?: 'loading' | 'scrollable' | 'playerPlaylist';
}
